/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019杭州吉簿云数字科技有限公司 All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 字典</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月02日</li>
 * <li>@author     : ____′↘林永雄</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import {heyuiConfig} from "heyui.ext";

heyuiConfig.initDict({
  accountingStandards: {
    SMALL_BUSINESS: '小企业会计准则',
    BUSINESS: '企业会计准则',
    BUSINESS20191: '企业会计准则(2019年未执行新金融准则、新收入准则和新租凭准则)',
    BUSINESS20192: '企业会计准则(2019年已执行新金融准则、新收入准则和新租赁准则)',
    NONGOVERNMENTAL: '民间非营利组织会计制度',
    FARMER: '农民专业合作社财务会计制度'
  },
  accountingStandardsPrint: {'SMALL_BUSINESS': "小企", 'BUSINESS': "企业"},
  reportPrint: {'zcfz': "01表", 'lr': "02表", 'xjll': "03表"},
  defaultRadios: [{key: true, title: '是'}, {key: false, title: '否'}],
  statusRadios: [{key: true, title: '正常'}, {key: false, title: '不可用'}],
  enableRadios: [{key: true, title: '启用'}, {key: false, title: '不启用'}],
  needRadios: [{key: true, title: '需要'}, {key: false, title: '不需要'}],
  reportTemplateType: {0: "普通报表", 1: "资产报表"},
  reportTemplateItemType: {0: "资产", 1: "负债", 2: "所有者权益"},
  accessRules: ["发生额", "借方发生额", "贷方发生额", "余额", "期初余额", "借方余额", "贷方余额"],
  biAccessRules: [ "借方发生额", "贷方发生额", "余额", "借方余额", "贷方余额"],
  zcfzAccessRules: ["余额", "借方余额", "贷方余额", "末级借方余额", "末级贷方余额", "辅助核算借方余额", "辅助核算贷方余额"],
  xjllAccessRules: ["余额", "借方余额", "贷方余额", "期初余额", "发生额", "借方发生额", "贷方发生额"],
  lrAccessRules: ["发生额", "贷方发生额"],
  operation: {'+': " +", '-': "-"},
  reportTemplateItemSources: {0: "表外公式", 1: "表内公式"},
  vatRadios: {'SMALL_SCALE': "小规模纳税人", 'COMMONLY': "一般纳税人"},
  roles: {'Manager': "账套管理员", 'Director': "主管", 'Making': "制单人", 'Cashier': "出纳", 'View': "查看"},
  voucherTemplateType: {0: "日常支出", 1: "采购", 2: "销售", 3: "工资", 4: "税金", 5: "折旧和摊销"},
  industry: {
    "0": "IT·通信·电子·互联网",
    "1": "金融业",
    "2": "房地产·建筑业",
    "3": "商业服务",
    "4": "贸易·批发·零售·租赁业",
    "5": "文体教育·工艺美术",
    "6": "生产·加工·制造",
    "7": "交通·运输·物流·仓储",
    "8": "服务业",
    "9": "文化·传媒·娱乐·体育",
    "10": "能源·矿产·环保",
    "11": "政府·非盈利机构",
    "12": "农·林·牧·渔·其他"
  },
  industryMapping: {
    "0": {
      mainBusiness: "软件开发、系统集成、信息技术咨询、运维服务",
      mainPurchase: "服务器、云服务、开发工具、知识产权授权、办公设备",
      mainSales: "定制化软件产品、SaaS服务、技术解决方案、信息化咨询服务",
      companyNature: "科技研发型", hasProduction: false, hasResearch: true, hasConstruction: false
    },
    "1": {
      mainBusiness: "金融产品销售、投融资服务、资产管理、风险管理",
      mainPurchase: "金融系统软件、办公设备、数据服务、合规咨询",
      mainSales: "贷款服务、投资理财产品、保险产品、金融咨询服务",
      companyNature: "金融型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "2": {
      mainBusiness: "房地产开发、工程施工、建筑安装、装饰装修、工程项目管理",
      mainPurchase: "土地使用权、建筑材料、工程设备、施工劳务、周转材料、安全防护用品",
      mainSales: "商品房销售、建筑工程服务、装饰工程服务、项目管理服务",
      companyNature: "建筑型", hasProduction: false, hasResearch: false, hasConstruction: true
    },
    "3": {
      mainBusiness: "设备租赁、企业管理咨询、法律服务、广告会展、商务代理",
      mainPurchase: "租赁设备、办公耗材、专业服务外包、营销推广资源",
      mainSales: "设备租赁服务、咨询报告、法律服务、广告策划与执行",
      companyNature: "服务型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "4": {
      mainBusiness: "商品批量采购、分销、零售、供应链管理及渠道销售服务",
      mainPurchase: "各类商品库存、包装材料、物流服务、办公设备及耗材",
      mainSales: "工业用品、建材、日用百货、食品、家居用品等商品",
      companyNature: "商贸型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "5": {
      mainBusiness: "教育培训、文体活动、工艺美术品设计制作与销售",
      mainPurchase: "教学设备、文体器材、工艺材料、办公耗材",
      mainSales: "培训服务、文体赛事服务、工艺美术品、设计服务",
      companyNature: "服务型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "6": {
      mainBusiness: "产品研发、生产加工、装配制造及自产产品销售",
      mainPurchase: "生产原材料、零部件、生产设备、包装材料、能源动力",
      mainSales: "自产工业产品、半成品、零配件及相关技术服务",
      companyNature: "生产型", hasProduction: true, hasResearch: false, hasConstruction: false
    },
    "7": {
      mainBusiness: "货物运输、客运服务、仓储保管、物流配送及运输代理服务",
      mainPurchase: "运输车辆、燃油、维修配件、仓储设备、保险服务",
      mainSales: "干线运输、同城配送、仓储租赁、物流解决方案",
      companyNature: "服务型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "8": {
      mainBusiness: "餐饮制作、住宿服务、家政保洁、生活配套服务",
      mainPurchase: "食材、酒水、客房用品、清洁设备、厨房设备",
      mainSales: "餐饮菜品、客房住宿、家政服务、生活增值服务",
      companyNature: "服务型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "9": {
      mainBusiness: "文化创作、传媒运营、娱乐活动策划、体育赛事服务",
      mainPurchase: "摄影器材、演出设备、版权授权、场地租赁、宣传推广",
      mainSales: "影视作品、广告服务、演出服务、赛事运营、版权授权",
      companyNature: "服务型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "10": {
      mainBusiness: "能源开采、矿产加工、环保治理、新能源开发",
      mainPurchase: "采矿设备、化工原料、环保设备、检测仪器、能源动力",
      mainSales: "矿产品、能源产品、环保工程服务、节能技术服务",
      companyNature: "生产型", hasProduction: true, hasResearch: false, hasConstruction: false
    },
    "11": {
      mainBusiness: "公共管理、社会服务、非营利组织运营",
      mainPurchase: "办公设备、公共设施维护材料、服务外包",
      mainSales: "公共服务、社会服务、公益项目",
      companyNature: "非营利型", hasProduction: false, hasResearch: false, hasConstruction: false
    },
    "12": {
      mainBusiness: "农作物种植、畜禽养殖、水产养殖、农产品初加工及销售",
      mainPurchase: "种子种苗、饲料、化肥农药、农机设备、包装材料、防疫用品",
      mainSales: "粮食、果蔬、畜禽产品、水产品、农产品加工品",
      companyNature: "生产型", hasProduction: true, hasResearch: false, hasConstruction: false
    }
  },
  assetsTemplateType: {
    '固定资产新增': '固定资产新增',
    '原值增加': '原值增加',
    '原值减少': '原值减少',
    '累计折旧变动': '累计折旧变动',
    '固定资产减少': '固定资产减少'
  },
});
